import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function CookiePolicy() {
  return (
    <div className="bg-[#0B1429] text-white min-h-screen">
      <Navbar />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="eyebrow mb-4">Legal</div>
          <h1 className="font-display font-black text-4xl md:text-5xl mb-10">Cookie Policy</h1>
          <div className="space-y-8 text-[#CBD5E1] text-base leading-relaxed">
            <div>
              <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">1. Introduction</h2>
              <p>
                This Cookie Policy explains how AMSC India 2026 uses cookies on this website.
                Effective date: 7 July 2026.
              </p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">2. The Cookie We Use</h2>
              <p>
                We use exactly one cookie: <code className="text-[#00F0FF]">access_token</code>, an
                <code className="text-[#00F0FF]"> httponly</code> session cookie that keeps you logged
                in after you sign in. It is strictly necessary for the site to function — without it,
                you would not be able to stay logged in to your athlete dashboard.
              </p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">3. What We Don't Use</h2>
              <p>
                We do not use analytics cookies, advertising cookies, or any third-party tracking
                cookies of any kind.
              </p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">4. Controlling Cookies</h2>
              <p>
                Because this cookie is strictly necessary, blocking it in your browser settings will
                prevent you from logging in and using authenticated features of the site (dashboard,
                event registration, etc.).
              </p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl md:text-2xl text-white mb-3">5. Contact</h2>
              <p>
                Questions about this policy? Email{" "}
                <a href="mailto:support@asianmastersbangalore2026.com" className="text-[#00F0FF]">
                  support@asianmastersbangalore2026.com
                </a>.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
